import { render, staticRenderFns } from "./ManejoDenuncias.vue?vue&type=template&id=f5289b08"
import script from "./ManejoDenuncias.vue?vue&type=script&lang=js"
export * from "./ManejoDenuncias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports